/**
 * metaClients.js — maps our clients to their Meta ad-account IDs (pulled from the
 * connected Ads API). Drives the Ads dashboard client switcher + report auto-fill.
 * Wiggly Butt (1382867672579946) is intentionally omitted — its account is unsettled
 * / not queryable. Edit here to add or remap accounts.
 */
export const META_CLIENTS = [
  { clientId: 'c12', name: 'Rashid Fabrics',                    adAccountId: '940290030922239',  currency: 'PKR' },
  { clientId: 'c6',  name: 'Fabrizia',                          adAccountId: '1759901491651554', currency: 'PKR' },
  { clientId: 'c5',  name: 'ISov',                              adAccountId: '526974047101817',  currency: 'PKR' },
  { clientId: 'c7',  name: 'Amina Khalid',                      adAccountId: '1776310573027358', currency: 'PKR' },
  { clientId: 'c1',  name: 'Padel Edge',                        adAccountId: '460350917091326',  currency: 'CAD' },
  { clientId: 'c4a', name: 'Signature by Eram',                 adAccountId: '6665609970151015', currency: 'PKR' },
  { clientId: 'c4b', name: 'Signature Aesthetics & Wellness',   adAccountId: '653701003469940',  currency: 'PKR' },
  { clientId: '',    name: 'Nael Luxe',                         adAccountId: '914598394852392',  currency: 'PKR' },
];

export function metaClientForId(clientId) {
  return META_CLIENTS.find(c => c.clientId && c.clientId === clientId) || null;
}
